/* unplugin-vue-components disabled */import script from "./DetailDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./DetailDrawer.vue?vue&type=style&index=0&id=779bd718&scoped=true&lang=less"
import "./DetailDrawer.vue?vue&type=style&index=1&id=779bd718&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-779bd718"]])

export default __exports__